export interface ApiConfig {
  apiBaseUrl: string;
  socketUrl: string;
}

let _config: ApiConfig = { apiBaseUrl: '', socketUrl: '' };

export const setApiConfig = (config: ApiConfig) => {
  _config = config;
};

export const getApiConfig = () => _config;
